export const count = <T>(array: T[], value: T) => array.filter((arrayItem) => arrayItem === value).length;
